import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      const hash = location.hash || "";
      const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
      const sessionId = params.get("session_id");
      // Preserve `?next=` so Google sign-in lands the customer back where they came from (e.g. /checkout)
      const nextUrl = sp.get("next") || "/account";
      if (!sessionId) { navigate("/auth", { replace: true }); return; }
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data?.ok) {
          window.history.replaceState({}, "", nextUrl);
          await refresh();
          toast.success("Welcome back, " + (data.user?.name || "friend"));
          navigate(nextUrl, { replace: true });
        } else {
          navigate("/auth", { replace: true });
        }
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh, sp]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-ink-700">
      <div className="text-center">
        <div className="eyebrow">Signing you in</div>
        <div className="mt-3 font-display text-2xl">One moment…</div>
      </div>
    </div>
  );
}
